<template>
        <!-- <el-container class="app-layout"> -->
            <!-- ===================================下级页面内容=================================== -->
            <router-view />
        <!-- </el-container> -->
</template>

<script>
export default {
    name: 'app-layout-empty',
    data () {
        return { };
    },
    mounted () {
    },
    methods: {
    }
};
</script>

<style lang="scss" scoped>
.app-layout {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;

    &.el-container {
        position: relative;
        height: 100%;
        color: var(--ar-color);
        background-color: var(--ar-color-bg);
    }

    .el-aside {
        position: relative;
        background-color: var(--ar-color-bg-sidebar);
        padding: 0.5em;
    }

    .el-header.banner {
        position: relative;
        background-color: var(--ar-color-bg-title);
        color: #333;
        text-align: left;
        height: 4em;
        .logo {
            height: 100%;
            vertical-align: bottom;
        }
        .title {
            font-size: 2em;
            line-height: 2em;
            color: var(--ar-color);
        }
        .menu-top {
            float: right;
            width: calc(100% - 60em);
            display: inline-block;
            vertical-align: bottom;
            border-bottom: unset;
            .el-menu-item {
                float: right;
                font-size: 1.1em;
            }
        }
    }
}
</style>
